import React from 'react';
import cn from 'classnames';
import LoaderDs from '@wix/da-ds/pkg/Loader';
import s from './Loader.scss';
const Loader = ({ type  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], type === 'drawer-suspense' && s['drawer-suspense'], type === 'drawer' && s['drawer'], type === 'feed' && s['feed'])
    }, /*#__PURE__*/ React.createElement(LoaderDs, {
        size: "big",
        className: s['loader']
    }));
};
Loader.displayName = 'Loader';
export default Loader;
